import { ValueType } from '@convergence/types';
import { useCallback } from 'react';
import { deepClone } from '../util';
import { AnalysisActionSwitch } from './analysis-action-switch';

export interface AnalysisInputRootProps {
  value: ValueType;
  analysisSchemaId: number;
  name: string;
  errors: { keyPath: string[]; message: string }[];
  onChange: (value: ValueType) => void;
}

export function AnalysisActionRoot(props: AnalysisInputRootProps) {
  const onChange = useCallback(
    (propertyPath: string[], newValue: unknown) => {
      const clone = deepClone(props.value);
      let current: any = clone;
      if (propertyPath.length === 0) {
        current._actionData = newValue;
      } else {
        for (const path of propertyPath) {
          if (current[path] === undefined) {
            current[path] = {};
          }
          if (path === propertyPath[propertyPath.length - 1]) {
            current[path]._actionData = newValue;
          } else {
            current = current[path];
          }
        }
      }
      props.onChange(clone);
    },
    [props.value, props.onChange]
  );

  return (
    <AnalysisActionSwitch
      tree={props.value}
      value={props.value}
      propertyPath={[]}
      name={props.name}
      onChange={onChange}
      errors={props.errors}
    />
  );
}
